(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["related-brand"] && !Shopify.designMode) return;
  try {
    (() => {
    const placeholder = document.querySelector('[data-related-brand]');
    if (!placeholder) return;

    const productHandle = (href) => {
      try {
        return new URL(href, location.origin).pathname.split('/').pop();
      } catch (error) {
        return null;
      }
    };

    let ownVendors = [];
    try {
      ownVendors = JSON.parse(placeholder.dataset.vendors || '[]');
    } catch (error) {}

    fetch(placeholder.dataset.url)
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const row = doc.querySelector('[data-related-brand-results]');
        if (!row) {
          placeholder.remove();
          return;
        }
        // Drop products already in the brand grid, and the brand itself
        const seen = new Set();
        document.querySelectorAll('.product-card__link').forEach((link) => {
          const handle = productHandle(link.getAttribute('href'));
          if (handle) seen.add(handle);
        });
        row.querySelectorAll('[data-related-item]').forEach((item) => {
          if (seen.has(item.dataset.relatedItem)) item.remove();
        });
        row.querySelectorAll('[data-related-vendor]').forEach((item) => {
          if (ownVendors.includes(item.dataset.relatedVendor)) item.remove();
        });
        const products = row.querySelector('[data-related-brand-products]');
        if (products && !products.querySelector('[data-related-item]')) products.remove();
        const vendors = row.querySelector('[data-related-brand-vendors]');
        if (vendors && !vendors.querySelector('[data-related-vendor]')) vendors.remove();
        if (row.querySelector('[data-related-item], [data-related-vendor]')) {
          placeholder.replaceWith(row);
        } else {
          placeholder.remove();
        }
      })
      .catch(() => placeholder.remove());
  })();
  } catch(e) { console.error(e); }
})();

})();
